import { Box, Card, Divider, Typography } from '@mui/material';
import { ReactNode } from 'react';

const DashboardFilterCard = ({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) => {
  return (
    <Card variant="outlined">
      <Typography
        sx={{
          fontSize: 14,
          paddingY: 1,
          textAlign: 'center',
          color: '#5A5A5A',
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>
      <Divider />
      <Box sx={{ padding: 2 }}>{children}</Box>
    </Card>
  );
};

export default DashboardFilterCard;
